import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { urlServer } from '../global_constants';
import { Referential } from '../models/referential';
import { ServiceResponse } from '../models/service-response';

@Injectable({
  providedIn: 'root'
})
export class TopicService {

  baseUrl=urlServer.concat("/v1/ref/topics");
  topicUrl=urlServer.concat("/v1/topic");
  
  public get token() : string|null {
    if(localStorage.getItem("token")!=null && localStorage.getItem("token")!=undefined) 
    return localStorage.getItem("token");
    return sessionStorage.getItem("token");
     
  }
  
  constructor(private httpClient:HttpClient) { }

  getTopics(){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    return this.httpClient.get<ServiceResponse>(this.baseUrl,{headers: header});
  }

  addTopic(topic: Referential){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    return this.httpClient.post<ServiceResponse>(this.topicUrl, topic, {headers: header});
  }

  updateTopic(topic: Referential){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    return this.httpClient.put<ServiceResponse>(this.topicUrl, topic, {headers: header});
  }

  deleteTopic(uuid: string){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    return this.httpClient.delete<ServiceResponse>(`${this.topicUrl}/${uuid}`,{headers: header});
  }

}
